export enum PathsEnum {
  ICONS = 'assets/icon/'
}
